export default __webpack_public_path__ + "static/DF_2018-fce94153b218c6362eeede338fb4230f.pdf";